import React from 'react';
import { Navbar } from '@/components/layout/Navbar';
import { Hero } from '@/components/sections/Hero';
import { Services } from '@/components/sections/Services';
import { About } from '@/components/sections/About';
import { Portfolio } from '@/components/sections/Portfolio';
import { Testimonials } from '@/components/sections/Testimonials';
import { Contact } from '@/components/sections/Contact';
import { Footer } from '@/components/layout/Footer';
import { Toaster } from '@/components/ui/sonner';
import { motion } from 'framer-motion';
export function HomePage() {
  return (
    <div className="min-h-screen bg-white selection:bg-brand-lime selection:text-brand-purple">
      <Navbar />
      <main>
        {/* L'entrée visuelle impactante */}
        <Hero />
        {/* Preuve de concept et expertise stratégique */}
        <About />
        {/* Grille de services 360° */}
        <Services />
        {/* Galerie des projets récents (Portfolio Dynamique) */}
        <Portfolio />
        {/* Preuve sociale et réassurance */}
        <Testimonials />
        {/* Section de capture de prospects */}
        <Contact />
      </main>
      <Footer />
      {/* Notifications system */}
      <Toaster position="top-right" richColors />
    </div>
  );
}